import { Nav } from "@/components/Nav";
import { GiuliaTeaser } from "@/components/GiuliaTeaser";

// Aperçu isolé du teaser Giulia (placé en haut pour capture). Non lié.
export default function TeaserPreviewPage() {
  return (
    <div className="relative min-h-screen bg-ink text-slate-50 antialiased">
      <div className="grain" aria-hidden="true" />
      <Nav onTip={() => {}} />
      <main className="pt-16"><GiuliaTeaser /></main>
    </div>
  );
}
